<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/prologue">Prologue</a></p>
<p class="toc1"><a href="#/chapter01">1. The New Zion</a></p>
<p class="toc"><a href="#/chapter02">2. The Year of the Golden Harvest</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. A Financial Cyclone Cellar</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Miners, Sheepmen, Cowboys and Bewildered Women</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. The Sierra Vista Castle</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Becoming a Land Baron</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Not a Snowball’s Chance</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. The Big Wheel in Town</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The Boudoir Burglary</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Trouble Brewing for LaVere Redfield</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Twenty-four Robbers at My Door</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. The Death of a Legend</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. The Redfield Hoard</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. The Redfield Legacy</span></p>
<p class="toc1"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?128dbf3c